import { type ReactNode } from 'react';
import { HStack, Text, VStack } from '@direct-frontend/components';
import styles from './DigitalCheckoutCharacteristic.module.css';

interface DigitalCheckoutCharacteristicGroupProps {
    children: ReactNode;
}

export const DigitalCheckoutCharacteristicGroup = ({ children }: DigitalCheckoutCharacteristicGroupProps) => (
    <VStack className={styles.group} gap="8">
        {children}
    </VStack>
);

interface DigitalCheckoutCharacteristicProps {
    title: string;
    content?: string | null;
}

export const DigitalCheckoutCharacteristic = ({ title, content }: DigitalCheckoutCharacteristicProps) => {
    if (!content) {
        return null;
    }

    return (
        <HStack className={styles.characteristic} justifyContent="space-between" gap="8">
            <Text size="m" role="supplementary" className={styles.title}>
                {title}
            </Text>
            <Text size="m" className={styles.content}>
                {content}
            </Text>
        </HStack>
    );
};
